module.exports = __webpack_public_path__ + "static/img/img-01.fa3559c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/img-01.jpg
// module id = 78
// module chunks = 0